import { render, staticRenderFns } from "./VersionTimeline.vue?vue&type=template&id=142cca09&scoped=true&"
import script from "./VersionTimeline.vue?vue&type=script&lang=js&"
export * from "./VersionTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VersionTimeline.vue?vue&type=style&index=0&id=142cca09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142cca09",
  null
  
)

export default component.exports